import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from '../../public/locales/en/common.json'
import zhTWCommon from '../../public/locales/zh-TW/common.json'
import zhCNCommon from '../../public/locales/zh-CN/common.json'
import jaCommon from '../../public/locales/ja/common.json'
import koCommon from '../../public/locales/ko/common.json'
import frCommon from '../../public/locales/fr/common.json'
import esCommon from '../../public/locales/es/common.json'

const resources = {
  en: { common: enCommon },
  'zh-TW': { common: zhTWCommon },
  'zh-CN': { common: zhCNCommon },
  ja: { common: jaCommon },
  ko: { common: koCommon },
  fr: { common: frCommon },
  es: { common: esCommon },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: ['common'],
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subpath'],
      caches: ['localStorage', 'cookie'],
    },
  })

export default i18n
